import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { PaymentRuleValidation } from 'uplisting-frontend/validations';

export default class PaymentRuleRepositoryService extends BaseRepositoryService<
  ModelRegistry['payment-rule']
> {
  recordName = 'payment-rule';
  implementMethods = [
    'findAll',
    'buildChangeset',
    'createRecord',
    'unloadAll',
    'peekAll',
  ];

  validation = PaymentRuleValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/payment-rule': PaymentRuleRepositoryService;
  }
}
